import './GanttChart.less';
import * as React from 'react';
import classNames from 'classnames';
import ganttGen from './gantt-chart-d3';
import moment, { MomentFormatSpecification } from 'moment';
// @ts-ignore
import _ from 'lodash';
import { getLocaleAttr } from 'utils/locales';

const TASKS = [
  {
    startDate: moment('2012-08-09'),
    endDate: new Date('Sun Dec 30 01:36:45 EST 2012'),
    taskName: '预计时间',
    status: 'RUNNING',
  },
  {
    startDate: new Date('Sun Dec 09 01:36:45 EST 2012'),
    endDate: new Date('Sun Dec 30 01:36:45 EST 2012'),
    taskName: '实际时间',
    status: 'DISABLED',
  },
];
const TASKS_STATUS = {
  SUCCEEDED: 'bar',
  DISABLED: 'bar-disabled',
  RUNNING: 'bar-running',
  KILLED: 'bar-killed',
};
const TASK_NAMES = ['预计时间', '实际时间'];
TASKS.sort((a: any, b: any) => {
  return a.endDate - b.endDate;
});
TASKS.sort((a: any, b: any) => {
  return a.startDate - b.startDate;
});

export interface GanttChartProps {
  prefixClas?: string;
  className?: string;
  tasks?: any[];
  taskNames?: any[];
  taskStatus?: any[];
  tickFormat?: MomentFormatSpecification;
  language: string;
}

export default class GanttChart extends React.Component<GanttChartProps, any> {

  private ganttChartRef: React.RefObject<HTMLDivElement>;
  private gantt: any;

  public static defaultProps = {
    prefixClas: 'mpc-gantt-chart',
    taskStatus: TASKS_STATUS,
    taskNames: TASK_NAMES,
    tickFormat: 'YYYY-MM-DD',
    tasks: TASKS,
  };

  constructor(props: GanttChartProps) {
    super(props);
    this.ganttChartRef = React.createRef();
  }

  public componentDidMount() {
    const { taskNames, tasks, tickFormat, taskStatus, language } = this.props;
    const opt = { margin: getLocaleAttr(language).ganttChartmarginLeft };
    // @ts-ignore
    this.gantt = ganttGen(opt).taskTypes(taskNames).taskStatus(taskStatus)
      .tickFormat(tickFormat).selector(this.ganttChartRef.current);
    this.gantt(tasks);
  }

  public componentWillReceiveProps(nextProps: GanttChartProps) {
    if (!_.isEqual(nextProps.tasks, this.props.tasks)) {
      this.drawGannt(nextProps);
    }
  }

  private drawGannt = (options: GanttChartProps = this.props) => {
    const { taskNames, tasks, tickFormat, taskStatus, language } = options;
    const opt = { margin: getLocaleAttr(language).ganttChartmarginLeft };
    // @ts-ignore
    this.gantt = ganttGen(opt).taskTypes(taskNames).taskStatus(taskStatus)
      .tickFormat(tickFormat).selector(this.ganttChartRef.current);
    this.gantt.redraw(tasks);
  }

  public render() {
    const {
      prefixClas,
      className,
    } = this.props;

    const classes = classNames(className, {
      [`${prefixClas}`]: true,
    });
    return (
      <div className={classes} ref={this.ganttChartRef} />
    );
  }
}
